import React from 'react';

import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { ConnectedQueryParamUpdateProvider } from '../../../bootstrap/routerHelpers/QueryParamUpdateProvider';
import { ConnectedPersonalSpace } from './ConnectedPersonalSpace';
import { PersonalSpaceOwnProps } from './PersonalSpace';

export interface PersonalSpaceProviderProps extends PersonalSpaceOwnProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
}

const PersonalSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'personal',
  subspaceName: undefined
};

export const PersonalSpaceProvider: React.FunctionComponent<PersonalSpaceProviderProps> = (props) => {

  const personalSpaceprops = {
    urls: props.urls
  };

  return (
    <ConnectedSpaceInfoProvider spaceInfo={PersonalSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={true}
        shouldUpdateContentTypes={true}
        shouldUpdateFilters={true}
        shouldUpdateSort={true}
      >
        <ConnectedPersonalSpace {...personalSpaceprops} />
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};
